import { isNil } from "lodash";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const isAuthenticated = () => {
    const token = cookies.get(process.env.REACT_APP_COOKIE_NAME);
    return !isNil(token);
};

export { isAuthenticated };